module.exports = __webpack_public_path__ + "img/Group 461.accb3987.png";